import { Component, OnInit } from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcReport, ExcReportAbo} from '../../report-service.service';
import {ExcFileItem} from '../../attachments/models/ExcFileItem';
import {DataImportUploadConfirmModalComponent} from '../../data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-modal-report-abo-edit',
  templateUrl: './modal-report-abo-edit.component.html',
  styles: []
})
export class ModalReportAboEditComponent extends ExcTranslation implements OnInit {
  private originalAbo: ExcReportAbo = null;
  private abo: ExcReportAbo = null;
  delivery = {Mail: false, Download: false};
  format = {Original: false, Pdf: false};
  report: ExcReport = null;
  reports: ExcReport[] = [];
  reportOptions: {text: string, value: number, disabled: boolean}[] = [];
  modeOptions: {text: string, value: string, disabled: boolean}[] = [
    {text: this.getRessource('ModeSchedule'), value: 'schedule', disabled: false},
    {text: this.getRessource('ModeEvent'), value: 'event', disabled: false}
  ];
  intervalOptions: {text: string, value: string, disabled: boolean}[] = [
    {text: this.getRessource('IntervalDaily'), value: 'daily', disabled: false},
    {text: this.getRessource('IntervalWeekly'), value: 'weekly', disabled: false},
    {text: this.getRessource('IntervalMonthly'), value: 'monthly', disabled: false}
  ];
  monthlyOptions: {text: string, value: string, disabled: boolean}[] = [
    {text: this.getRessource('MonthlyFirst'), value: 'first', disabled: false},
    {text: this.getRessource('MonthlyLast'), value: 'last', disabled: false},
    {text: this.getRessource('MonthlySpecific'), value: 'specific', disabled: false}
  ];
  specificDayOptions: {text: string, value: number, disabled: boolean}[] = [
    {text: '2.', value: 2, disabled: false},
    {text: '3.', value: 3, disabled: false},
    {text: '4.', value: 4, disabled: false},
    {text: '5.', value: 5, disabled: false},
    {text: '6.', value: 6, disabled: false},
    {text: '7.', value: 7, disabled: false},
    {text: '8.', value: 8, disabled: false},
    {text: '9.', value: 9, disabled: false},
    {text: '10.', value: 10, disabled: false},
    {text: '11.', value: 11, disabled: false},
    {text: '12.', value: 12, disabled: false},
    {text: '13.', value: 13, disabled: false},
    {text: '14.', value: 14, disabled: false},
    {text: '15.', value: 15, disabled: false},
    {text: '16.', value: 16, disabled: false},
    {text: '17.', value: 17, disabled: false},
    {text: '18.', value: 18, disabled: false},
    {text: '19.', value: 19, disabled: false},
    {text: '20.', value: 20, disabled: false},
    {text: '21.', value: 21, disabled: false},
    {text: '22.', value: 22, disabled: false},
    {text: '23.', value: 23, disabled: false},
    {text: '24.', value: 24, disabled: false},
    {text: '25.', value: 25, disabled: false},
    {text: '26.', value: 26, disabled: false},
    {text: '27.', value: 27, disabled: false},
    {text: '28.', value: 28, disabled: false}
  ];
  timeOptions: {text: string, value: string, disabled: boolean}[] = [
    {text: '00:00', value: '00:00', disabled: false},
    {text: '00:30', value: '00:30', disabled: false},
    {text: '01:00', value: '01:00', disabled: false},
    {text: '01:30', value: '01:30', disabled: false},
    {text: '02:00', value: '02:00', disabled: false},
    {text: '02:30', value: '02:30', disabled: false},
    {text: '03:00', value: '03:00', disabled: false},
    {text: '03:30', value: '03:30', disabled: false},
    {text: '04:00', value: '04:00', disabled: false},
    {text: '04:30', value: '04:30', disabled: false},
    {text: '05:00', value: '05:00', disabled: false},
    {text: '05:30', value: '05:30', disabled: false},
    {text: '06:00', value: '06:00', disabled: false},
    {text: '06:30', value: '06:30', disabled: false},
    {text: '07:00', value: '07:00', disabled: false},
    {text: '07:30', value: '07:30', disabled: false},
    {text: '08:00', value: '08:00', disabled: false},
    {text: '08:30', value: '08:30', disabled: false},
    {text: '09:00', value: '09:00', disabled: false},
    {text: '09:30', value: '09:30', disabled: false},
    {text: '10:00', value: '10:00', disabled: false},
    {text: '10:30', value: '10:30', disabled: false},
    {text: '11:00', value: '11:00', disabled: false},
    {text: '11:30', value: '11:30', disabled: false},
    {text: '12:00', value: '12:00', disabled: false},
    {text: '12:30', value: '12:30', disabled: false},
    {text: '13:00', value: '13:00', disabled: false},
    {text: '13:30', value: '13:30', disabled: false},
    {text: '14:00', value: '14:00', disabled: false},
    {text: '14:30', value: '14:30', disabled: false},
    {text: '15:00', value: '15:00', disabled: false},
    {text: '15:30', value: '15:30', disabled: false},
    {text: '16:00', value: '16:00', disabled: false},
    {text: '16:30', value: '16:30', disabled: false},
    {text: '17:00', value: '17:00', disabled: false},
    {text: '17:30', value: '17:30', disabled: false},
    {text: '18:00', value: '18:00', disabled: false},
    {text: '18:30', value: '18:30', disabled: false},
    {text: '19:00', value: '19:00', disabled: false},
    {text: '19:30', value: '19:30', disabled: false},
    {text: '20:00', value: '20:00', disabled: false},
    {text: '20:30', value: '20:30', disabled: false},
    {text: '21:00', value: '21:00', disabled: false},
    {text: '21:30', value: '21:30', disabled: false},
    {text: '22:00', value: '22:00', disabled: false},
    {text: '22:30', value: '22:30', disabled: false},
    {text: '23:00', value: '23:00', disabled: false},
    {text: '23:30', value: '23:30', disabled: false}
  ];
  outputOptions: {text: string, value: string, disabled: boolean}[] = [
    {text: this.getRessource('FormatOriginal'), value: '', disabled: false},
    {text: this.getRessource('FormatPdf'), value: 'pdf', disabled: false}
  ];
  eventOptions: {text: string, value: string, disabled: boolean}[] = [
    {text: this.getRessource('EventAuditStart'), value: 'auditstart', disabled: false},
    {text: this.getRessource('EventAuditEnd'), value: 'auditend', disabled: false},
    {text: this.getRessource('EventAuditReject'), value: 'auditreject', disabled: false},
    {text: this.getRessource('EventAuditExpire'), value: 'auditexpire', disabled: false},
    {text: this.getRessource('EventReviewInbox'), value: 'reviewinbox', disabled: false},
    {text: this.getRessource('EventReviewEnd'), value: 'reviewend', disabled: false}
    ];
  timespanOptions: {text: string, value: number, disabled: boolean}[] = [
    {text: this.getRessource('LastSent'), value: 0, disabled: false},
    {text: '1', value: 1, disabled: false},
    {text: '2', value: 2, disabled: false},
    {text: '3', value: 3, disabled: false},
    {text: '4', value: 4, disabled: false},
    {text: '5', value: 5, disabled: false},
    {text: '6', value: 6, disabled: false},
    {text: '7', value: 7, disabled: false},
    {text: '8', value: 8, disabled: false},
    {text: '9', value: 9, disabled: false},
    {text: '10', value: 10, disabled: false},
    {text: '11', value: 11, disabled: false},
    {text: '12', value: 12, disabled: false},
    {text: '13', value: 13, disabled: false},
    {text: '14', value: 14, disabled: false},
    {text: '15', value: 15, disabled: false},
    {text: '16', value: 16, disabled: false},
    {text: '17', value: 17, disabled: false},
    {text: '18', value: 18, disabled: false},
    {text: '19', value: 19, disabled: false},
    {text: '20', value: 20, disabled: false},
    {text: '21', value: 21, disabled: false},
    {text: '22', value: 22, disabled: false},
    {text: '23', value: 23, disabled: false},
    {text: '24', value: 24, disabled: false},
    {text: '25', value: 25, disabled: false},
    {text: '26', value: 26, disabled: false},
    {text: '27', value: 27, disabled: false},
    {text: '28', value: 28, disabled: false},
    {text: '29', value: 29, disabled: false},
    {text: '30', value: 30, disabled: false}
  ];
  timespanUnitOptions: {text: string, value: string, disabled: boolean}[] = [
    {text: this.getRessource('Day'), value: 'day', disabled: false},
    {text: this.getRessource('Week'), value: 'week', disabled: false},
    {text: this.getRessource('Month'), value: 'month', disabled: false}
  ];
  selected = {
    SpecificDay: null,
    Monday: null,
    Tuesday: null,
    Wednesday: null,
    Thursday: null,
    Friday: null,
    Saturday: null,
    Sunday: null
  };
  templateOptions: {text: string, value: number, disabled: boolean}[] = [];
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
  }
  ngOnInit() {
    this.reports = this.overlayConfig.data.Reports;
    for (const x of this.reports) {
      this.reportOptions.push({text: x.rptName + (x.rptDescription !== null ? ' (' + x.rptDescription + ')' : ''), value: x.rptID, disabled: false});
    }
    for (const t of this.overlayConfig.data.Templates) {
      this.templateOptions.push({text: t.rpatName, value: t.rpatID, disabled: false});
    }
    this.originalAbo = this.overlayConfig.data.Abo.Clone();
    this.abo = this.originalAbo.Clone();
    this.initData();
  }
  getReport() {
    this.initData();
  }
  reset() {
    this.abo = this.originalAbo.Clone();
    this.initData();
  }
  changeMode() {
    if (this.abo.rpaMode === 'schedule') {
      this.abo.rpaRecipientSelfcheck = false;
      this.abo.rpaRecipientDealer = false;
    }
  }
  initData() {
    this.report = null;
    for (const x of this.reports) {
      if (x.rptID === this.abo.rpa_rptID) {
        this.report = x;
        break;
      }
    }
    if (this.report === null) {
      this.report = this.reports[0];
      this.abo.rpa_rptID = this.report.rptID;
    }
    if (this.report !== null) {
      this.modeOptions[0].disabled = this.report.rptTimeDriven === false;
      this.modeOptions[1].disabled = this.report.rptTargetAudit === false;

      this.outputOptions[0].disabled = true;
      this.outputOptions[0].text = this.getRessource('FormatOriginal');
      this.outputOptions[1].disabled = true;
      if (this.report.rptOutputFormats.indexOf('xlsx') > -1) {
        this.outputOptions[0].disabled = false;
        this.outputOptions[0].text = this.getRessource('Format_xlsx');
        this.outputOptions[0].value = 'xlsx';
      }
      if (this.report.rptOutputFormats.indexOf('docx') > -1) {
        this.outputOptions[0].disabled = false;
        this.outputOptions[0].text = this.getRessource('Format_docx');
        this.outputOptions[0].value = 'docx';
      }
      if (this.report.rptOutputFormats.indexOf('pdf') > -1) {
        this.outputOptions[1].disabled = false;
      }
      if (this.abo.rpaInterval === 'weekly') {
        this.selected.Monday = this.abo.rpaIntervalTarget.indexOf('mo') > -1;
        this.selected.Tuesday = this.abo.rpaIntervalTarget.indexOf('di') > -1;
        this.selected.Wednesday = this.abo.rpaIntervalTarget.indexOf('mi') > -1;
        this.selected.Thursday = this.abo.rpaIntervalTarget.indexOf('do') > -1;
        this.selected.Friday = this.abo.rpaIntervalTarget.indexOf('fr') > -1;
        this.selected.Saturday = this.abo.rpaIntervalTarget.indexOf('sa') > -1;
        this.selected.Sunday = this.abo.rpaIntervalTarget.indexOf('so') > -1;
      } else if (this.abo.rpaInterval === 'monthly') {
        if (this.abo.rpaIntervalTarget !== 'first' && this.abo.rpaIntervalTarget !== 'last') {
          this.selected.SpecificDay = parseInt(this.abo.rpaIntervalTarget, 0);
          this.abo.rpaIntervalTarget = 'specific';
        }
      }
      if (this.abo.rpaMode === null) {
        if (!this.modeOptions[0].disabled) {
          this.abo.rpaMode = this.modeOptions[0].value;
        } else {
          this.abo.rpaMode = this.modeOptions[1].value;
        }
      } else {
        if (this.modeOptions[0].disabled && this.abo.rpaMode === this.modeOptions[0].value) {
          this.abo.rpaMode = this.modeOptions[1].value;
        }
        if (this.modeOptions[1].disabled && this.abo.rpaMode === this.modeOptions[1].value) {
          this.abo.rpaMode = this.modeOptions[0].value;
        }
      }
    }
  }
  isComplete(): boolean {
    if (this.abo.rpa_rptID === null) {
      return false;
    }
    if (this.abo.rpaMode === null) {
      return false;
    }
    if (this.abo.rpa_rpatID === null) {
      return false;
    }
    if (this.abo.rpaMode === 'event') {
      if (this.abo.rpaEvent === null) {
        return false;
      }
    } else {
      if (this.abo.rpaInterval === null) {
        return false;
      }
      if (this.abo.rpaInterval === 'weekly') {
          if (!this.selected.Sunday && !this.selected.Saturday && !this.selected.Friday && !this.selected.Thursday
              && !this.selected.Wednesday && !this.selected.Tuesday && !this.selected.Monday) {
            return false;
          }
      }
      if (this.abo.rpaInterval === 'monthly') {
        if (this.abo.rpaIntervalTarget === null) {
          return false;
        }
        if (this.abo.rpaIntervalTarget === 'specific' && this.selected.SpecificDay === null) {
          return false;
        }
      }
      if (this.abo.rpaIntervalDaytime === null) {
        return false;
      }
    }
    if (this.abo.rpaFormat === null) {
      return false;
    }
    if (this.abo.rpaRecipients === null && !this.abo.rpaRecipientDealer && !this.abo.rpaRecipientSelfcheck) {
      return false;
    }
    return true;
  }
  proceed() {
    if (this.abo.rpaInterval === 'weekly') {
      let x = '';
      if (this.selected.Monday) {
        x += '|mo';
      }
      if (this.selected.Tuesday) {
        x += '|di';
      }
      if (this.selected.Wednesday) {
        x += '|mi';
      }
      if (this.selected.Thursday) {
        x += '|do';
      }
      if (this.selected.Friday) {
        x += '|fr';
      }
      if (this.selected.Saturday) {
        x += '|sa';
      }
      if (this.selected.Sunday) {
        x += '|so';
      }
      this.abo.rpaIntervalTarget = x.substring(1, x.length);
    } else if (this.abo.rpaInterval === 'monthly') {
      if (this.abo.rpaIntervalTarget === 'specific') {
        this.abo.rpaIntervalTarget = this.selected.SpecificDay;
      }
    }
    const obj = {
      proceed: true,
      Abo: this.abo
    };
    this.overlayRef.close(obj);
  }
}
